import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnchor2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAnchor2"><Path d="M12 8.25C13.5188 8.25 14.75 7.01878 14.75 5.5C14.75 3.98122 13.5188 2.75 12 2.75C10.4812 2.75 9.25 3.98122 9.25 5.5C9.25 7.01878 10.4812 8.25 12 8.25ZM12 8.25V21M18 12H21.25C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAnchor2;
